import type { Control, FieldErrors, UseFormRegister } from 'react-hook-form';
import { Card } from '@/components/ui/Card';
import { TextField } from '@/components/forms/TextField';
import { UI_STRINGS } from '@/lib/constants/ui-strings';
import type { InvestorProfileFormValues } from './schema';
import { InvestorLocationFields } from './InvestorLocationFields';

const S = UI_STRINGS.INVESTOR_PROFILE;

interface LocationSectionProps {
  control: Control<InvestorProfileFormValues>;
  register: UseFormRegister<InvestorProfileFormValues>;
  errors?: FieldErrors<InvestorProfileFormValues>;
}

/**
 * The Location panel's address fields (US-040 AC3, FR-188). Street, city and postal code
 * are text; Country and State are dropdowns. The read view is `InvestorLocationCard` (MYN-217).
 */
export function LocationSection({ control, register, errors }: LocationSectionProps) {
  return (
    <Card title={S.LOCATION} headerDivider hoverEffect={false}>
      {/* Short address parts two to a row. */}
      <div className="grid gap-4 sm:grid-cols-2">
        <TextField
          {...register('addressStreet')}
          label={S.ADDRESS_STREET_1}
          labelVariant="caps"
          error={errors?.addressStreet?.message}
        />
        <TextField
          {...register('addressStreet2')}
          label={S.ADDRESS_STREET_2}
          labelVariant="caps"
          error={errors?.addressStreet2?.message}
        />
        <TextField
          {...register('addressCity')}
          label={S.CITY}
          labelVariant="caps"
          error={errors?.addressCity?.message}
        />
        <TextField
          {...register('addressPostalCode')}
          label={S.POSTAL_CODE}
          labelVariant="caps"
          error={errors?.addressPostalCode?.message}
        />
        <InvestorLocationFields control={control} errors={errors} />
      </div>
    </Card>
  );
}
